import React from 'react'
import MiniHeader from '../../../../components/layout/MiniHeader/index'
import Card from '../../../../components/common/Card/index'
import Typography from '../../../../components/common/Typography/index'
import Button from '../../../../components/common/Button/index'
import { IoCheckmarkCircle } from 'react-icons/io5'

const Subscription = () => {
  const plans = [
    {
      name: 'Basic',
      price: '$9.99',
      period: 'month',
      features: [
        'Up to 10 property listings',
        'Basic analytics',
        'Email support',
        'Standard templates'
      ],
      current: false
    },
    {
      name: 'Professional',
      price: '$29.99',
      period: 'month',
      features: [
        'Up to 100 property listings',
        'Advanced analytics',
        'Priority support',
        'Custom templates',
        'Lead management',
        'Marketing tools'
      ],
      current: true
    },
    {
      name: 'Enterprise',
      price: '$99.99',
      period: 'month',
      features: [
        'Unlimited property listings',
        'Full analytics suite',
        '24/7 phone support',
        'White-label solution',
        'Advanced integrations',
        'Custom development'
      ],
      current: false
    }
  ]

  return (
    <div className="p-6">
      <MiniHeader title="Subscription Plans" />
      
      <div className="mt-6">
        <Typography variant="h2" className="mb-4">
          Choose Your Plan
        </Typography>
        <Typography className="text-gray-600 mb-8">
          Select the perfect plan for your real estate business needs
        </Typography>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map((plan, index) => (
            <Card key={index} className={`p-6 ${plan.current ? 'border-2 border-blue-500' : ''}`}>
              {plan.current && (
                <div className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm mb-4 inline-block">
                  Current Plan
                </div>
              )}
              
              <Typography variant="h3" className="mb-2">
                {plan.name}
              </Typography>
              
              <div className="mb-4">
                <span className="text-3xl font-bold">{plan.price}</span>
                <span className="text-gray-600">/{plan.period}</span>
              </div>
              
              <ul className="space-y-3 mb-6">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center">
                    <IoCheckmarkCircle className="text-green-500 mr-2" />
                    <Typography className="text-sm">{feature}</Typography>
                  </li>
                ))}
              </ul>
              
              <Button 
                variant={plan.current ? "secondary" : "primary"}
                className="w-full"
                disabled={plan.current}
              >
                {plan.current ? 'Current Plan' : 'Upgrade'}
              </Button>
            </Card>
          ))}
        </div>
        
        <div className="mt-12">
          <Typography variant="h3" className="mb-4">
            Billing Information
          </Typography>
          
          <Card className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Typography variant="h4" className="mb-2">
                  Current Subscription
                </Typography>
                <Typography className="text-gray-600">
                  Professional Plan - $29.99/month
                </Typography>
                <Typography className="text-sm text-gray-500 mt-1">
                  Next billing date: January 15, 2024
                </Typography>
              </div>
              
              <div>
                <Typography variant="h4" className="mb-2">
                  Payment Method
                </Typography>
                <Typography className="text-gray-600">
                  **** **** **** 1234
                </Typography>
                <Typography className="text-sm text-gray-500 mt-1">
                  Expires 12/25
                </Typography>
              </div>
            </div>
            
            <div className="mt-6 flex gap-4">
              <Button variant="secondary">
                Update Payment Method
              </Button>
              <Button variant="outline">
                Download Invoice
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default Subscription